import type { ReferenceMaterial } from 'app/types/attachment';
import { useTranslate } from 'core/hooks/useTranslate';
import { onClickOpenReferenceMaterial } from 'core/utils/referenceMaterial';
import { useParams } from 'react-router';
import { useToasts } from 'react-toast-notifications';

export function useOpenReferenceMaterial(courseGuid?: string): (material?: ReferenceMaterial | null) => void {
  const { courseGuid: routeCourseGuid } = useParams<{ courseGuid?: string }>();
  const { t } = useTranslate();
  const { addToast } = useToasts();

  return (material) => {
    onClickOpenReferenceMaterial(material, courseGuid || routeCourseGuid, () => {
      addToast(t('common:Oops! This page is not available'), { appearance: 'warning', autoDismiss: true });
    });
  };
}
